import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { faqErrorCode, faqErrorMessage } from '../../api/faq'
import { downloadBlob, responseFilename } from '../../lib/download'

// A button that fetches an .xlsx from the FAQ API and saves it.
// `fetchFile` returns the blob response; `fallbackName()` names the file when
// the browser may not read the server's file name (called at download time).
export default function FaqDownloadButton({ label, fetchFile, fallbackName, className, onPermissionDenied }) {
  const { t } = useTranslation()
  const [busy, setBusy] = useState(false)

  const download = async () => {
    setBusy(true)
    try {
      const response = await fetchFile()
      downloadBlob(response.data, responseFilename(response, fallbackName()))
    } catch (error) {
      toast.error(faqErrorMessage(t, error))
      if (faqErrorCode(error) === 'permission_denied') onPermissionDenied?.()
    } finally {
      setBusy(false)
    }
  }

  return (
    <button type="button" onClick={download} disabled={busy} aria-busy={busy} className={className}>
      {busy ? t('faq.export.working') : label}
    </button>
  )
}
